import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
  Periodo,
  ThreeDots,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import useEntradaSaidaInsumo, { LOADING_MESSAGES } from './EntradaSaidaInsumoHook'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import EntradaSaidaInsumoModal from './EntradaSaidaInsumoModal'

function EntradaSaidaInsumo({ history, dispatch, selectedTp }) {
  const { state, localDispatch } = useEntradaSaidaInsumo()
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    if (selectedTp) localDispatch.onSelectedTpChange(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    if (state.loadingMessage === LOADING_MESSAGES.NONE) {
      dispatch(hideLoadingBox())
    } else if (state.loadingMessage === LOADING_MESSAGES.FETCHING) {
      dispatch(showLoadingBox(state.loadingMessage, 'Aguarde'))
      localDispatch.getMovimentacoes(state.pInicial, state.pFinal, selectedTp)
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])
  // Render
  return (
    <>
      <PageHeader>7.2 - Entrada e Saída - Insumo</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.onBtnNovoClick(selectedTp)}
          onVoltar={history.goBack}
        >
          <div className="p-grid">
            <div className="p-col-4">
              <Periodo
                periodoInicial={state.pInicial}
                periodoFinal={state.pFinal}
                isLoading={state.loadingMessage === LOADING_MESSAGES.FETCHING}
                onPesquisar={(pInicial, pFinal) => localDispatch.onPeriodoChange(pInicial, pFinal)}
              />
            </div>
            <div className="p-col-12">
              <DataTable
                value={state.movimentacoes}
                emptyMessage={'Não existe nenhuma movimentação'}
                paginator={true}
                rows={10}
                header={<CustomDataTableHeader onChange={setGlobalFilter} />}
                globalFilter={globalFilter}
              >
                <Column field={'mov_date_formatted'} header={'Data'} style={tableCellCentered()} />
                <Column field={'insumo_name'} header={'Insumo'} />
                <Column
                  field={'operacao_name'}
                  header={'Operação'}
                  style={tableCellCentered(250)}
                />
                <Column field={'qte'} header={'Quantidade'} style={tableCellCentered(150)} />
                <Column
                  header={'Menu'}
                  style={tableCellCentered(80)}
                  body={movimento => (
                    <ThreeDots
                      items={['Excluir']}
                      onClick={() => localDispatch.onExcluir(movimento)}
                    />
                  )}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <EntradaSaidaInsumoModal
        visible={state.showModal}
        onResponse={localDispatch.onModalResponse}
        insumos={state.insumos}
        operacoes={state.operacoes}
        movimentacao={state.selectedMovimentacao}
      />
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(EntradaSaidaInsumo))
